import {
    App, Button, Row, Typography
} from 'antd';

import React, { useState, useEffect} from "react";
import PanelFrameWithImage from "./PanelFrameWithImage";
import { imageLocations } from "../image/ImageLocations";
import { useTranslation } from "react-i18next";
import useOnlineStatus from "../../utility/hooks/useOnlineStatus";
import { useScreenSizeBelow } from "../../utility/hooks/useScreenSize";
import { getQuotationPortalLink } from "../../../src/api/security";
import {showApiError} from "../../utility/error/error-handler";

const { Text} = Typography;

const CreateQuotePanel = ({backgroundType, loadingProgress, setLoadingProgress, }) => {
  const { t } = useTranslation();
  const { notification } = App.useApp();
  const { isOnline } = useOnlineStatus();
  // const [loadingProgress, setLoadingProgress] = useState(0);  //start 0 - button shows loading if less than 100

  const Buttons = () => {
    return (
      isOnline
      ?
      <Button type="primary" 
              target="_blank"
              loading={loadingProgress !== 100} 
              onClick={(e) => createQuoteButton(e)}
      >
        {t('action.new_quote')}
      </Button>
      :
      <></>
    );
  }      

  const createQuoteButton = (e) => {
    // Moved the getApexurl to here as there is a time limit on the token when authenticating on Apex's side
    // in the event the driver stays a while before accessing the quote app, there is the likelihood quote portal authentication may fail
      if (isOnline)
        {
          getQuotationPortalLink(setLoadingProgress).then(res => {
            window.open(res, "_new")},)
            .catch(err => {
              // Show error if online otherwise show dash if offline (not been on this vehicle or cache not working)
              showApiError(t('title.quotes'), err, notification);
          });
        } else {
          // OFFLINE
          setLoadingProgress(100);
          }        
    };     

    const PanelMessage = () => {
      let displayHeight=130;
  
      if (useScreenSizeBelow(576)) {
          displayHeight = null;
      }

      return (
              <div style={{height: displayHeight, overflow:'auto'}}>
                  {/* Message still TBD */}
                  <Text>{t('message.no_open_quotes')}</Text>
              </div>
              )
    }

    return (
      <div> 
          {
              <PanelFrameWithImage title={t('title.quotes')}
                                    imageLocation={imageLocations.QUOTE_IMAGE}
                                    backgroundType={backgroundType} height="260px"
                                    buttons={<Buttons />}
              >
                  <Row>
                      <PanelMessage></PanelMessage>
                  </Row>            
              </PanelFrameWithImage>
          }
      </div>
  );
}

export default CreateQuotePanel;